import React from 'react';
import TableHead from './TableHead';
import TableBody from './TableBody';

const Table = ({ transfers }) => {
    const empty = (transfers.length === 0);
    if (empty) {
        return (
            <div className="rounded-0 alert alert-warning m-0">
                Nenhum repasse efetuada até o momento.
            </div>
        );
    }
    return (
        <div className="table-responsive">
            <table className="table table-hover align-items-center table-flush">
                <TableHead />
                <TableBody transfers={transfers} />
            </table>
        </div>
    );
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/Table.js